<template>
  <div class="page-card">
    <el-card>
      <div slot="header">积分中心 - 实物礼品兑换管理</div>
      <el-form :inline="true" size="small" @submit.native.prevent>
        <el-form-item label="礼品名称">
          <el-input v-model="query.title" placeholder="礼品名称" clearable />
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" placeholder="全部" clearable style="width: 140px;">
            <el-option label="上架" value="上架" />
            <el-option label="下架" value="下架" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="fetchList">查询</el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="success" @click="openEdit()">新增礼品</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="list" border stripe>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="图片" width="120">
          <template slot-scope="scope">
            <img
              v-if="scope.row.image"
              :src="scope.row.image"
              style="width: 90px; height: 60px; object-fit: cover; border-radius: 4px;"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="礼品名称" />
        <el-table-column prop="price" label="参考价格" width="100" />
        <el-table-column prop="exchangePoints" label="兑换积分" width="100" />
        <el-table-column prop="stock" label="库存" width="80" />
        <el-table-column prop="status" label="状态" width="90" />
        <el-table-column prop="order" label="排序" width="80" />
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-dialog :title="editForm.id ? '编辑礼品' : '新增礼品'" :visible.sync="editVisible" width="700px">
        <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="100px">
          <el-form-item label="礼品名称" prop="title">
            <el-input v-model="editForm.title" placeholder="请输入礼品名称" />
          </el-form-item>
          <el-form-item label="礼品图片" prop="image">
            <el-upload
              :key="uploadKey"
              class="avatar-uploader"
              action=""
              list-type="picture-card"
              :file-list="imageFileList"
              :limit="1"
              :http-request="uploadGiftImage"
              :before-upload="beforeImageUpload"
              :on-remove="handleImageRemove"
              :on-exceed="handleImageExceed"
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <el-form-item label="参考价格">
            <el-input v-model="editForm.price" placeholder="如：39.9 元" />
          </el-form-item>
          <el-form-item label="兑换积分" prop="exchangePoints">
            <el-input-number v-model="editForm.exchangePoints" :min="1" :max="999999" />
          </el-form-item>
          <el-form-item label="库存">
            <el-input-number v-model="editForm.stock" :min="0" :max="999999" />
          </el-form-item>
          <el-form-item label="订购电话">
            <el-input v-model="editForm.phone" placeholder="选填" />
          </el-form-item>
          <el-form-item label="实体店地址">
            <el-input v-model="editForm.address" placeholder="选填" />
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="editForm.status" style="width: 140px;">
              <el-option label="上架" value="上架" />
              <el-option label="下架" value="下架" />
            </el-select>
          </el-form-item>
          <el-form-item label="排序">
            <el-input-number v-model="editForm.order" :min="0" :max="9999" />
          </el-form-item>
          <el-form-item label="描述">
            <el-input v-model="editForm.description" type="textarea" :rows="3" placeholder="选填" />
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="editVisible = false">取消</el-button>
          <el-button type="primary" @click="save">保存</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import request, { normalizeMediaUrl, pickUploadResponsePayload, resolveUploadedFileUrl } from '@/api/request'

export default {
  name: 'GiftExchangeList',
  data() {
    return {
      query: {
        title: '',
        status: ''
      },
      list: [],
      editVisible: false,
      uploadKey: 0,
      imageFileList: [],
      editForm: {
        id: null,
        title: '',
        image: '',
        price: '',
        exchangePoints: 100,
        stock: 0,
        phone: '',
        address: '',
        status: '上架',
        order: 0,
        description: ''
      },
      editRules: {
        title: [{ required: true, message: '请输入礼品名称', trigger: 'blur' }],
        exchangePoints: [{ required: true, message: '请填写兑换积分', trigger: 'change' }],
        image: [
          {
            validator: (rule, value, callback) => {
              if (this.editForm.image || (this.imageFileList && this.imageFileList.length)) callback()
              else callback(new Error('请上传礼品图片'))
            },
            trigger: 'change'
          }
        ]
      }
    }
  },
  created() {
    this.fetchList()
  },
  methods: {
    fetchList() {
      request.get('/promo/gifts', { params: this.query }).then(res => {
        const data = res.data || res
        const items = (data && data.items) || []
        this.list = items.map(x => ({
          ...x,
          image: normalizeMediaUrl(x.image || '') || x.image
        }))
      })
    },
    resetQuery() {
      this.query.title = ''
      this.query.status = ''
      this.fetchList()
    },
    openEdit(row) {
      if (row && row.id) {
        const img = normalizeMediaUrl(row.image || '') || row.image || ''
        this.editForm = {
          id: row.id,
          title: row.title || '',
          image: img,
          price: row.price || '',
          exchangePoints: Number(row.exchangePoints || 100),
          stock: Number(row.stock || 0),
          phone: row.phone || '',
          address: row.address || '',
          status: row.status || '上架',
          order: Number(row.order || 0),
          description: row.description || ''
        }
        this.imageFileList = img ? [{ name: 'image', url: img }] : []
      } else {
        this.editForm = {
          id: null,
          title: '',
          image: '',
          price: '',
          exchangePoints: 100,
          stock: 0,
          phone: '',
          address: '',
          status: '上架',
          order: 0,
          description: ''
        }
        this.imageFileList = []
      }
      this.uploadKey += 1
      this.editVisible = true
    },
    save() {
      this.$refs.editForm.validate(valid => {
        if (!valid) return
        const payload = { ...this.editForm }
        const req = payload.id ? request.put(`/promo/gifts/${payload.id}`, payload) : request.post('/promo/gifts', payload)
        req.then(() => {
          this.$message.success('保存成功')
          this.editVisible = false
          this.fetchList()
        })
      })
    },
    remove(row) {
      this.$confirm('确认删除该礼品吗？', '提示', { type: 'warning' }).then(() => {
        request.delete(`/promo/gifts/${row.id}`).then(() => {
          this.$message.success('删除成功')
          this.fetchList()
        })
      })
    },
    beforeImageUpload(file) {
      const okType = ['image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'].includes(file.type)
      if (!okType) {
        this.$message.error('仅支持 png/jpg/jpeg/webp/gif')
        return false
      }
      if (file.size / 1024 / 1024 > 5) {
        this.$message.error('图片大小不能超过 5MB')
        return false
      }
      return true
    },
    uploadGiftImage(req) {
      const form = new FormData()
      form.append('file', req.file)
      request
        .post('/upload', form, { headers: { 'Content-Type': 'multipart/form-data' } })
        .then(res => {
          const data = pickUploadResponsePayload(res)
          const url = resolveUploadedFileUrl(data)
          if (!url) throw new Error('empty url')
          this.imageFileList = [{ name: req.file.name || 'image', url }]
          this.editForm.image = url
          req.onSuccess && req.onSuccess({ url })
        })
        .catch(err => {
          this.$message.error('图片上传失败')
          req.onError && req.onError(err)
        })
    },
    handleImageExceed() {
      this.$message.warning('只能上传 1 张礼品图')
    },
    handleImageRemove(file, fileList) {
      const list = Array.isArray(fileList) ? fileList : []
      this.imageFileList = list
      this.editForm.image = list.length ? list[0].url : ''
    }
  }
}
</script>
